export interface InputConfig {
  min: number;
  max: number;
}

export enum IncrementInputEvent {
  INCREMENT_CHANGE = 'incrementInputChange',
  MIN_VALUE_REACHED = 'minValueReached',
  MAX_VALUE_REACHED = 'maxValueReached',
}
